module.exports = __webpack_public_path__ + "static/media/image-howto-4.ec93860c.jpg";